module.exports = __webpack_public_path__ + "static/img/icon_info.c8409268.png";